import { render, staticRenderFns } from "./LogManagementViewModal.vue?vue&type=template&id=6f623590&"
import script from "./LogManagementViewModal.vue?vue&type=script&lang=js&"
export * from "./LogManagementViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports